import { useTranslation } from "react-i18next";

import View from "components/elements/View";

function Tickets(): JSX.Element {
  const { t } = useTranslation();

  return (
    <View title={t("tickets.title")}>
      <p>Tickets</p>
    </View>
  );
}

export default Tickets;
